<template>
<div style="z-index: 10; position: relative;">
  <label for="title" class="titleForm">{{label}}</label>
  <v-toolbar dense class="toolbarCustom">
    <v-overflow-btn
      :items="flags"
      hide-details
      class="pa-0 flagPicker"
      v-model="selectedFlag"
      name="flag"
      :value-comparator="valueCompare"
      :item-value="null"
      :attach="true"
    >
      <template v-slot:item="{item}" :name="item.icon">
        <v-row justify="space-between">
          <v-col cols="8" class="d-flex align-center">
            <CountryFlag :icon="item.icon.toLowerCase()" :size="24"/>
            <span class="ml-2" v-translate> {{ `${item.country_name} (${item.icon})` }} </span>
          </v-col>
          <v-col style="text-align: right" cols="4" >
            <strong class="ml-2" v-translate> {{ `(+${item.prefix})` }} </strong>
          </v-col>
        </v-row>
      </template>

      <template v-slot:selection="{item}" :name="item.icon">
        <CountryFlag :icon="item.icon.toLowerCase()" :size="24" class="ml-3"/>
      </template>
      <template v-slot:label>
        <CountryFlag :icon="selectedFlag.icon.toLowerCase()" :size="24"/>
      </template>
    </v-overflow-btn>
    <v-text-field
      v-model="telephone"
      name="telephone"
      :prefix="`(+${selectedFlag.prefix})`"
      solo
      hide-details
      class="telephoneInput text-md-subtitle-1 body-2"
      type="number"
      @keypress="onlyNumber"
    ></v-text-field>
  </v-toolbar>
</div>
</template>

<script>
import code_En from '@/json/country_codes_En'
import code_Fr from '@/json/country_codes_Fr'
import CountryFlag from "@/components/CountryFlag";
export default {
  name: 'Telephone',
  components:{CountryFlag},
  data() {
    return {
      selectedFlag: {
        icon: 'fr',
        prefix: '033'
      },
      telephone: null
    }
  },
  props: {
    value: { type: String, default: null },
    label: { type: String, default: null },
    phoneCode: { type: String, default: null },
    countryCode: { type: String, default: null },
    isSmall: { type: Boolean, default: false }
  },
  computed: {
    codeEN() {
      return code_En
    },
    codeFR() {
      return code_Fr
    },
    flags() {
      return localStorage.currentLanguage == 'en_EN' ? this.codeEN : this.codeFR
    },
    defaultFlag() {
      const country = JSON.parse(localStorage.country)
      console.log('localStorage.country: ', country.id);
      if(country && country.id) {
        console.log('localStorage.country.id: ', country.id.toLowerCase());
        return country.id.toLowerCase()
      } else return this.selectedFlag
    }
  },
  mounted() {
    if(this.value && this.phoneCode) {
      this.telephone = this.value.substring(4);
      const code = this.value.substring(1, 4);
      if (this.telephone == '' || this.telephone == 'null') {
        this.selectedFlag = this.flags.find(flag => flag.icon.toLowerCase() == this.countryCode.toLowerCase());
      }
      if (this.telephone == 'null' && this.countryCode) {
        this.selectedFlag = this.flags.find(flag => flag.icon.toLowerCase() == this.countryCode.toLowerCase());
        this.telephone = null;
      }

      if (this.telephone !== '' && this.telephone != 'null') {
        this.selectedFlag = this.flags.find(flag => flag.prefix == code && flag.icon == this.phoneCode );
      }
    } else if(this.countryCode) {
      this.selectedFlag = this.flags.find(flag => flag.icon.toLowerCase() == this.countryCode.toLowerCase());
    }
  },
  watch: {
    telephone() {
      if (this.selectedFlag) {
        this.$emit('input', '+' + this.selectedFlag.prefix + this.telephone);
      }
    },
    countryCode() {
      if (this.value == null) {
        this.selectedFlag = this.flags.find(flag => flag.icon.toLowerCase() == this.countryCode.toLowerCase());
      }
    },
    selectedFlag() {
      if (this.selectedFlag) {
        this.$emit('input', '+' + this.selectedFlag.prefix + this.telephone);
        this.$emit('flag', this.selectedFlag);
      }
    }
  },
  methods: {
    valueCompare (a, b) {
      return a ? (b ? a.icon == b.icon : true) : false;
    },
    onlyNumber ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
        $event.preventDefault();
      }
    }
  }
};
</script>
<style>
@media screen and (max-width: 767px) {
  .flagPicker .v-menu__content {
    width: 15rem !important;
    overflow-y: auto;
    background: #F2F2F2;
    min-width: 15rem !important;
    z-index: 10 !important;
  }
}
@media screen and (min-width: 767px) {
  .flagPicker .v-menu__content {
    width: 22rem !important;
    overflow-y: auto;
    background: #F2F2F2;
    min-width: 22rem !important;
    z-index: 20 !important;
  }
}
  .v-application .v-menu__content .v-list {
    background: #fff;
    font-size: 0.875rem !important;
  }
  .v-application .v-menu__content::-webkit-scrollbar {
    width: 10px;
  }
  .v-application .v-menu__content::-webkit-scrollbar-track {
    transparent: 0;
  }
  .v-application .v-menu__content::-webkit-scrollbar-thumb {
    background: #179D4E;
    border-radius: 7px;
    opacity: 0.5;
  }
  .v-application .v-menu__content::-webkit-scrollbar-thumb:hover {
    cursor: pointer;
    opacity: 1;
  }
  .v-sheet.v-toolbar:not(.v-sheet--outlined) {
    box-shadow: none;
    -webkit-box-shadow: none;
  }
</style>